"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanField = void 0;
const register_1 = require("../../register");
exports.BooleanField = (0, register_1.buildField)({
    serialize: (value, buf) => {
        const buf2 = Buffer.from([0]);
        if (value) {
            buf2.writeUInt8(1);
        }
        return Buffer.concat([buf, buf2]);
    },
    deserialize: (buf) => {
        if (buf.length === 0)
            throw new Error();
        const val = buf.readUInt8();
        if (val > 1)
            throw new Error();
        return [
            val > 0,
            buf.slice(1),
        ];
    }
});
//# sourceMappingURL=boolean.js.map